import axios from './axios-instance';

export function login(payload) {
  return axios.post('/unioncenter/web-background/account/login', payload);
}

export function logout() {
  return axios.post('/unioncenter/web-background/account/logout');
}

export function editPwd(payload = {}) {
  return axios.post('/unioncenter/web-background/account/changeSelfPassword', payload);
}

export function loginByCode(code) {
  return axios.get('/unioncenter/account/login-by-qrcode', { params: { code } });
}

export function getUserInfo() {
  return axios.get('/unioncenter/token/userinfo');
}

export function getUserFunctions() {
  return axios.get('/unioncenter/web-background/role-function/get-user-functions');
}

// 获取租户续约信息
export function apiGetTenantContract() {
  return axios.get('/unioncenter/tenant-contract/alarm/message');
}
